/**
 * PATH: packages/ui/src/kanban/components/card-detail/resolveInlineDrawerWrapperStyle.ts
 * FILE_ID: UI-KANBAN-INLINE-DRAWER-WRAPPER-STYLE-001
 * PURPOSE: Pure I→O for CardDetailDrawer wrapper CSS (inline / popup / pinned).
 * WHY: A closed inline pane still published width (~320px). That empty flex
 *   sibling squeezed Table / Calendar / Dashboard and left a blank right band
 *   while the Emails FAB was the only visible chrome (QT-6215).
 * FLOW:
 *   flags + width → hide or reserve → CSSProperties | undefined
 */

export type InlineDrawerWrapperStyle =
  | { display: 'none' }
  | { width: string }
  | Record<string, never>
  | undefined

export interface ResolveInlineDrawerWrapperStyleArgs {
  popup: boolean
  inlineMode: boolean
  inlineActive: boolean
  open: boolean
  isNarrowViewport: boolean
  drawerWidth: number
  pinned: boolean
}

/**
 * f(mode flags) → wrapper style.
 * Hidden whenever the inline pane is not the visible slot (wrong tab OR
 * closed / collapsed). Hidden panes must not set width — Emails/Jobs already
 * unmount when closed; this pane stays mounted for keep-alive.
 */
export function resolveInlineDrawerWrapperStyle(
  args: ResolveInlineDrawerWrapperStyleArgs,
): InlineDrawerWrapperStyle {
  const {
    popup,
    inlineMode,
    inlineActive,
    open,
    isNarrowViewport,
    drawerWidth,
    pinned,
  } = args
  const hideInline = inlineMode && (!open || !inlineActive)

  if (popup) {
    return hideInline ? { display: 'none' } : undefined
  }
  if (inlineMode) {
    if (hideInline) return { display: 'none' }
    return isNarrowViewport ? {} : { width: `${drawerWidth}px` }
  }
  if (pinned) return { width: `${drawerWidth}px` }
  return undefined
}
